import type { LegacyPermission } from '../config/permissions';
import { getLegacyAuthClaims, hasLegacyPermission } from '../lib/auth-claims';

/**
 * The old panel's `useCheckAccess()` — returns a `check(permission)` function
 * for imperative gates (disabled tints, inert clicks), where the declarative
 * `<LegacyCheckAccess>` hide-children wrapper does not fit. Claims are read
 * from storage per render, as the source read `localStorage` per render.
 */
export function useLegacyAccess(): (permission: LegacyPermission) => boolean {
  const claims = getLegacyAuthClaims();
  return function checkAccess(permission: LegacyPermission): boolean {
    return hasLegacyPermission(claims, permission);
  };
}
